import WebOfficialSupport from '../views/webOfficialSupport/WebOfficialSupport.vue';

export default [
  {
    path: '/',
    name: '',
    component: WebOfficialSupport
  },
  {
    path: '/creatework',
    name: 'creatework',
    component: WebOfficialSupport
  },
  {
    path: '/mylist',
    name: 'mylist',
    component: WebOfficialSupport
  },
  {
    path: '/mywork/:workId',
    name: 'mywork',
    component: WebOfficialSupport
  },
  {
    path: '/worktemp',
    name: 'worktemp',
    component: WebOfficialSupport
  }
];
